export default __webpack_public_path__ + "static/media/logoBlack.54dc3fdc.png";